<template>
  <v-card color="grey lighten-3">
    <v-card-title>
      <h3 class="checkout-h3">Mapa do local</h3>
    </v-card-title>
    <v-card-text class="grey--text text-xs-center">

    <panZoom
      v-if="coordinates && coordinates.length"
      id="panz"
      @init="onInit"
      :style="`overflow: hidden; outline: none !important; cursor: move; max-height: ${this.$vuetify.breakpoint.xs ? '350px' : '600px' }; ${this.$vuetify.breakpoint.xs ? 'max-width: 350px;' : '' }`"
      :options="{minZoom: isSmAndDown ? 0.48 : 0.6, maxZoom: isSmAndDown ? 4 : 4, zoomSpeed: !isSmAndDown ? 0.195 : 0.195, pinchSpeed: 0.010, zoomDoubleClickSpeed: 1, bounds: isSmAndDown ? true : true, boundsPadding: 0.1}"
    >
      <svg id="svgId" class="noselect" width="770px" height="700px" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
        <g class="noselect"  style="cursor: default;">
          <image class="noselect" :xlink:href="mapUrl" width="770px" height="653" x="0" y="0"></image>
          <polygon v-for="(coordinate, i) in coordinates" :key="i" :id="coordinate.productId" slot="activator" :style="sectors.find(s => s.codigo === hoverShape) ? 'cursor: pointer' : ''" v-touch="setSeatToSelect" @mouseenter="handleMouse(coordinate.productId)" @mouseleave="handleMouse(null)" class="noselect" sector-id="961069" :opacity="hoverShape === coordinate.productId  ? '1' : '0'" fill="rgba(255,255,0,0.5)" :points="coordinate.shape"></polygon>
        </g>
      </svg>
    </panZoom>
    <div v-else>
      <img ref="imgEvent" class="map__img" v-if="mapUrl" :src="mapUrl" alt="Evento" />
      <div v-else class="text-xs-center">Indisponível</div>
    </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['mapUrl'],
  data() {
    return {
      hover: false,
      windowWidth: 0,
      stageSize: {
        width: 600,
        height: 600
      },
      seats: [],
      panInst: null,
      panId: null,
      pzx: null,
      pzy: null,
      mapSize: 475,
      selectedSeat: null,
      image: null,
      coordinates: null
    }
  },
  computed: {
    ...mapGetters(['eventID', 'hoverShape', 'sectors', 'noSectorProducts', 'separateProducts'])
  },
  mounted () {
    this.organizeShapes()
  },
  methods: {
    organizeShapes () {
      let array = []
      if (this.sectors && this.sectors.length) {
        this.sectors.forEach(p => {
          if (p.mapa_coordenadas) p.mapa_coordenadas.forEach(shape => {
            let findedShape = array.find(obj => obj.shape == shape)
            if (!findedShape) array.push({shape: shape, productId: p.codigo})
          })
        })
      }
      if (this.separateProducts) {
        this.separateProducts.forEach(p => {
        if (p.mapa_coordenadas) p.mapa_coordenadas.forEach(shape => {
          let findedShape = array.find(obj => obj.shape == shape)
          if (!findedShape) array.push({shape: shape, productId: p.codigo_produto})
        })
      })
      }
      this.coordinates = array
    },
    setSeatToSelect(el) {
      this.selectSector(el.target.id)
    },
    selectSector (index) {
      let isSector = null
      if (this.$vuetify.breakpoint.xs && index) isSector = this.sectors.find(s => s.codigo === Number(index))
      else isSector = this.sectors.find(s => s.codigo === this.hoverShape)
      if (isSector) {
        this.$store.commit('SET_HOVER_SHAPE', null)
        this.$store.dispatch('setSelectedSector', isSector);
      }
    },
    handleMouse (value) {
      this.$store.commit('SET_HOVER_SHAPE', value)
    },
    onInit: function(panzoomInstance, id) {
      this.pzx = document.getElementById('panz').offsetWidth;
      this.pzy = document.getElementById('panz').offsetHeight;
      this.panInst = panzoomInstance
      this.panId = id

      if(!this.isSmAndDown) {
        panzoomInstance.moveTo((this.pzx - this.mapSize - 130)/2, 0)
        panzoomInstance.zoomAbs(0, 0, 0.8);
      }
      else {
        panzoomInstance.moveTo(0, 30)
        panzoomInstance.zoomAbs(0, 0, 0.48);
      }

      this.mapIsReady = true
    },
  }
};
</script>

<style>
.polygon:hover {
  background-color: red !important;
}
.polygons-area {
  position: absolute;
}
.noselect {
  -webkit-touch-callout: none !important; /* iOS Safari */
  -webkit-user-select: none !important; /* Safari */
  -khtml-user-select: none !important; /* Konqueror HTML */
  -moz-user-select: none !important; /* Old versions of Firefox */
  -ms-user-select: none !important; /* Internet Explorer/Edge */
  user-select: none !important; /* Non-prefixed version, currently                           supported by Chrome, Opera and Firefox */
}
</style>
